import { useSelector } from 'react-redux';
import { ClinicUnits } from '../TeamListing/types';

export const useGetMyTeams = () => {
  const clinician_clinics = useSelector(
    (state) => state.clinicianProfile.clinics,
  );

  const myTeams = clinician_clinics.filter(
    (clinic) => clinic.organisation_unit === ClinicUnits.TEAM,
  );

  const myAccessableTasks = (myTeams || []).reduce((accumulator, myTeam) => {
    const teamTasks = myTeam?.features?.tasks ?? [];
    teamTasks.forEach((task) => {
      const index = accumulator.findIndex((item) => item.id === task.id);
      if (index === -1) {
        accumulator.push(task);
      }
    });

    return accumulator;
  }, []);

  return {
    myTeams,
    myAccessableTasks,
  };
};
